/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import React, { useContext, useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  BreadCrumbs,
  Button,
  Checkbox,
  ConfirmationDialog,
  DatePicker,
  DropArea,
  FormErrorMessage,
  Select,
  SelectWithSearch,
  TextInput,
  UserSideBar,
} from "../../components";
import SelectWithBackendSearch from "../../components/Select/SelectWithBackendSearch";
import { FileTypes, ToastVariants } from "../../models";
import { formatCurrency, formatPhoneNumber, onFileError, priceReview, RequestTypeTitle, validateEmail, validatePhoneOrFaxNumber } from "../../utils";
import { AmountReplaceRegex, DiscountValueRegex, Phone_Fax_Regex, SESSION_STORAGE_NEW_REQUEST, colors } from "../../utils/constants";
import useHomeRoute from "../../hooks/useHomeRoute";
import moment from "moment";
import { AuthPermission, UserState, authService } from "../../services/auth.service";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { RootState, AppDispatch } from "../../redux/store";
import { useSelector, useDispatch } from "react-redux";
import { getOffice, getOfficeCareProviders, searchOfficePatients, getOfficeUsersWithPermission } from "../../redux/slices/OfficeSlice";
import { searchServiceData } from "../../redux/slices/ServiceSlice";
import { User } from "../../models/user.model";
import AddEditFee from "../../components/forms/AddEditFee/AddEditFee";
import { addRequest, addRequestNote } from "../../redux/slices/OnBoardingSlice";
import { clearRequestData } from "../../redux/slices/OfficeRequestSlice";
import { Service, ServiceBilledTo, ServiceOwner } from "../../models/service.model";
import { listOfficeRequests } from "../../redux/slices/OfficeRequestSlice";
import { RequestDiscountType, RequestType as NewRequestType } from "../../models/request.model";
import { InputsTypes, inputsInitialState, serviceBilled } from "./CreateRequestData";
import { clearUploadedFiles } from "../../redux/slices/FileSlice";
import { searchOfficeUser } from "../../redux/slices/UserSlice";
import { UserType } from "../../services/user.service";
import { Contact, ContactMethodType } from "../../models/contact.model";
import { ContactService } from "../../services/contact.service";
import { InvoiceDetails, PriceDetails } from "../../models/price-details.model";
import { OfficeService } from "../../services/office.service";
import { UpdateRequest } from "../../models/update-request.model";
import { UpdateFee } from "../../models/update-fee.model";
import { useDebouncedCallback } from "use-debounce";
import { OfficeState } from "../../models/office.model";
import { ToastContext } from "../../contexts/ToastContext/ToastContext";
import { getPssData, getRequestData } from "../../redux/slices/CurrentUserSlice";
export interface PssAuthResponse {
  authKey?: string;
  officeId: string;
  officePss: boolean;
  // add other properties if needed
}

let isEmailChange = false;
const windowObj = window as any;

const CreateRequestScreen = () => {
  const { id } = useParams();
  const { homeLink } = useHomeRoute();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const toast = useContext(ToastContext);
  const maxNumOfFilesUpload = 10;
  const [inputs, setInputs] = useState([...inputsInitialState]);
  const [errorInitiated, setErrorInitiated] = useState(false);
  const [showPatientInviteDialog, setShowPatientInviteDialog] = useState(false);
  const currentPermissions = authService.currentUserPermissions;
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const { primaryCareProvider } = useSelector((state: RootState) => state.office);
  const { loading: fileLoading } = useSelector((state: RootState) => state.file);
  const { currentUser } = useSelector((state: RootState) => state.currentUser);
  const breadCrumbItems = [
    { key: `/offices`, title: `Offices` },
    { key: `/offices/${currentOffice?.officeId}/requests`, title: currentOffice?.name },
    { key: `/offices/${currentOffice?.officeId}/requests`, title: `Requests` },
    { key: "#", title: `Request a Service` },
  ];
  const { requestData, loading } = useSelector((state: RootState) => state.officeRequest);
  const { userWithPermission, patientList } = useSelector((state: RootState) => state.office);
  const { pending } = useSelector((state: RootState) => state.onBoarding);
  const [formType, setFormType] = useState<NewRequestType | undefined>(undefined);
  const allServices = useSelector((state: RootState) => state.service.serviceList.data?.content);
  const [selectedPatient, setSelectedPatient] = useState<any>();
  const [services, setServices] = useState(allServices);
  const [staff, setStaff] = useState<{ label: string; value: string }[]>([]);
  const [addSideBarOpen, setAddSideBarOpen] = useState<boolean>(false);
  const [officeStaff, setOfficeStaff] = useState<string>("");
  const [careProvider, setCareProvider] = useState<string>("");
  const [mpcNumber, setMpcNumber] = useState<string>("");
  const [addRequestError, setAddRequestError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState();
  const [selectedService, setSelectedService] = useState<Service | undefined>(undefined);
  const [serviceNotesValue, setServiceNotesValue] = useState<string>("");
  const [serviceNotesError, setServiceNotesError] = useState<boolean>(false);
  const [messageValue, setMessageValue] = useState<string>("");
  const [filesValidationError, setFilesValidationError] = useState<boolean>(false);
  const [selectedPatientId, setSelectedPatientId] = useState<string | undefined>(undefined);
  const [discountType, setDiscountType] = useState(RequestDiscountType.Percentage);
  const [discountValue, setDiscountValue] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountError, setDiscountError] = useState(false);
  const [selectsearch, setselectSearch] = useState("");
  const [selectPatientsearch, setselectPatientSearch] = useState("");
  const [searchedUserData, setSearchedUserData] = useState<User | null>(null);
  const [officeContacts, setOfficeContacts] = useState<Contact[]>([]);
  const [selectedContactsearch, setSelectContactSearch] = useState("");
  const [selectedContact, setSelectedContact] = useState<Contact | undefined>(undefined);
  const [selectedContactMethod, setContactMethod] = useState<ContactMethodType>(ContactMethodType.Email);
  const [priceDetails, setPriceDetails] = useState<PriceDetails | undefined>(undefined);
  const [additionalFees, setAdditionalFees] = useState<UpdateFee[] | undefined>(undefined);
  const [dropAreaError, setDropAreaError] = useState<string>("");
  const [pssData, setPssData] = useState<PssAuthResponse | null>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const patientOptions = patientList?.data?.content;
  const billedto = inputs.find(f => f.id === "billedto")?.value as string;
  let billedToSent: ServiceBilledTo;
  switch (formType) {
    case NewRequestType.QuickFormOffice:
    case NewRequestType.PrescriptionRefill:
    case NewRequestType.DocnoteDebit:
      billedToSent = ServiceBilledTo.Patient;
      break;
    default:
      billedToSent = billedto as ServiceBilledTo;
      break;
  }

  const [searchParams] = useSearchParams();
  const [reqData, setReqData] = useState<any>();
  const [lockedFromPrefill, setLockedFromPrefill] = useState<Record<string, boolean>>({});
  const fetchPrefilledData = async (TemId: string) => {
    const res = await dispatch(getRequestData({ officeId: TemId }));
    const prefilledRequestData = res.payload as any | null;
    if (prefilledRequestData?.redirectUrl) {
      toast?.openToast("Request already created.", 2000, ToastVariants.Error);
      window.location.href = prefilledRequestData.url;
    }
    if (res.payload === "") {
      toast?.openToast("Request not found.", 2000, ToastVariants.Error);
    }
    setReqData(prefilledRequestData);
    if (prefilledRequestData?.requestType) {
      setFormType(prefilledRequestData.requestType);
    }
    if (prefilledRequestData?.contactPersonId) {
      setSelectedPatientId(prefilledRequestData.contactPersonId);
    }
    if (prefilledRequestData?.recipientName && prefilledRequestData?.recipientContact) {
      const filteredContacts = officeContacts.find(
        contact =>
          prefilledRequestData?.recipientName === contact.company &&
          (reqData?.recipientContact === contact.email || reqData?.recipientContact === contact.fax)
      );
      setContactMethod(filteredContacts?.contactPreference as ContactMethodType);
      setSelectedContact(filteredContacts);
    }
    // lock specific fields if they are provided by prefill (affects only this prefill case)
    const newLocks: Record<string, boolean> = {};
    ["firstName", "lastName", "email", "phone", "dateOfBirth", "ohipNumber"].forEach(key => {
      if (
        prefilledRequestData &&
        prefilledRequestData[key] !== undefined &&
        prefilledRequestData[key] !== null &&
        `${prefilledRequestData[key]}` !== ""
      ) {
        newLocks[key] = true;
      }
    });
    setLockedFromPrefill(newLocks);
  };
  useEffect(() => {
    const TemId = searchParams.get("apireqid");
    if (TemId && !selectedContact?.company) {
      fetchPrefilledData(TemId as string);
    }
  }, [searchParams, officeContacts]);

  useEffect(() => {
    if ((currentUser?.offices && currentUser.offices.length > 0 && currentUser.offices[0]?.officeId) || currentOffice?.officeId) {
      getData();
    }
  }, [currentUser, currentOffice]);

  const getData = async () => {
    const validId = currentUser?.offices && currentUser.offices.length > 0 ? currentUser.offices[0]?.officeId : currentOffice?.officeId;
    const res = await dispatch(getPssData({ officeId: validId as string }));
    const pssResponse = res.payload as PssAuthResponse | null;
    setPssData(pssResponse);
  };

  const {
    servicePrice,
    dscDesc,
    dscValue,
    blockFeeDiscountDesc,
    blockFeeDiscountAmount,
    additionalFeeTotal,
    subTotal,
    dsFee,
    dsFeeDesc,
    hstValue,
    hstPercentage,
    hstDesc,
    total,
  } = priceReview(priceDetails);

  const firstName = (inputs.find(f => f.id === "firstName")?.value as string).trim();
  const birthday = inputs.find(f => f.id === "dateOfBirth")?.value as string;
  const details = (inputs.find(f => f.id === "details")?.value as string).trim();
  const recipientFieldMap: Partial<Record<NewRequestType, string>> = {
    [NewRequestType.WSIBOffice]: "recipientNameV2",
    [NewRequestType.ThirdPartyOffice]: "recipientNameV2",
    [NewRequestType.ServiceCanadaOffice]: "recipientNameV2",
    [NewRequestType.PrescriptionRefill]: "pharmacyName",
  };

  const recipientContactFieldMap: Partial<Record<NewRequestType, string>> = {
    [NewRequestType.WSIBOffice]: "emailOrFaxNew",
    [NewRequestType.ThirdPartyOffice]: "emailOrFaxNew",
    [NewRequestType.ServiceCanadaOffice]: "emailOrFaxNew",
    [NewRequestType.PrescriptionRefill]: "pharmacyEmailOrFax",
  };

  const recipientField = formType && recipientFieldMap[formType] ? recipientFieldMap[formType] : "recipientName"; // Fallback default
  const recipientContactField = formType && recipientContactFieldMap[formType] ? recipientContactFieldMap[formType] : "emailOrFax";
  const recipientName = (inputs.find(f => f.id === recipientField)?.value as string).trim();
  const childs = inputs.map(f => {
    if (f.child) {
      return f.child[0];
    } else {
      return null;
    }
  });
  const files = inputs.find(f => f.id === "files")?.value as any;
  const newFiles: string[] = files && files?.length ? files.split(",") : [];
  const lastName = (childs.find(f => f?.id === "lastName")?.value as string).trim();
  const ohipNumber = childs.find(f => f?.id === "ohipNumber")?.value as string;
  const email = (inputs.find(f => f?.id === "email")?.value as string).trim();
  const phoneNumber = (childs.find(f => f?.id === "phone")?.value as string).trim();
  const recipientContact = childs.find(f => f?.id === recipientContactField)?.value as string;
  const typeOfService = inputs.find(f => f.id === "typeOfService")?.value as string;
  const servicePriceOverride = childs.find(f => f?.id === "servicePrice")?.value as string;
  const serviceNotes = inputs.find(f => f.id === "note")?.value as string;
  let finalServiceBilled: any = [];
  switch (formType) {
    case NewRequestType.ThirdPartyOffice:
      finalServiceBilled = serviceBilled.filter((item: any) => item.id === ServiceBilledTo.ThirdParty);
      break;
    case NewRequestType.WSIBOffice:
      finalServiceBilled = serviceBilled.filter((item: any) => item.id === ServiceBilledTo.WSIB);
      break;
    case NewRequestType.ServiceCanadaOffice:
      finalServiceBilled = serviceBilled.filter((item: any) => item.id === ServiceBilledTo.ServiceCanada);
      break;
    default:
      finalServiceBilled = serviceBilled;
  }
  const MAX_VISIBLE_INPUTS = 16;

  const loadPatients = (id: string, term = "", page = 0, size = 100) => {
    dispatch(searchOfficePatients({ officeId: id, page: page, size: size, sort: "", term: term, userState: UserState.Active }));
  };

  const patientDebounced = useDebouncedCallback(val => {
    if (id) loadPatients(id, val);
  }, 400);

  useEffect(() => {
    const updated = [...inputs];
    let email = true;
    let dob = true;
    let pharmacy = false;
    let file = false;
    let hideAdditionalCheck = false;
    let billedToValue = "";
    let showBilledTo = false;
    switch (formType) {
      case NewRequestType.QuickFormOffice:
        {
          dob = true; // Show dateOfBirth and ohipNumber for QuickFormOffice
          file = false;
          const newServices = allServices?.filter(f => f.serviceBilledTo === ServiceBilledTo.Patient || f.serviceBilledTo === undefined);
          setServices(newServices);
        }
        break;
      case NewRequestType.PrescriptionRefill:
      case NewRequestType.DocnoteDebit:
        {
          dob = false;
          file = formType === NewRequestType.PrescriptionRefill; // Only required for PrescriptionRefill
          if (formType === NewRequestType.PrescriptionRefill) {
            pharmacy = true;
          }
          if (formType === NewRequestType.DocnoteDebit) {
            file = false;
          }
          const newServices = allServices?.filter(f => f.serviceBilledTo === ServiceBilledTo.Patient || f.serviceBilledTo === undefined);
          setServices(newServices);
        }
        break;
      case NewRequestType.ThirdPartyOffice:
        {
          const newServices = allServices?.filter(f => f.serviceBilledTo === ServiceBilledTo.ThirdParty || f.serviceBilledTo === undefined);
          setServices(newServices);
          email = true;
          hideAdditionalCheck = true;
          billedToValue = ServiceBilledTo.ThirdParty;
        }
        break;
      case NewRequestType.WSIBOffice:
        {
          const newServices = allServices?.filter(f => f.serviceBilledTo === ServiceBilledTo.WSIB || f.serviceBilledTo === undefined);
          setServices(newServices);
          email = true;
          hideAdditionalCheck = true;
          billedToValue = ServiceBilledTo.WSIB;
        }
        break;
      case NewRequestType.ServiceCanadaOffice:
        {
          const newServices = allServices?.filter(f => f.serviceBilledTo === ServiceBilledTo.ServiceCanada || f.serviceBilledTo === undefined);
          setServices(newServices);
          email = true;
          hideAdditionalCheck = true;
          billedToValue = ServiceBilledTo.ServiceCanada;
        }
        break;
      case NewRequestType.StandardOffice:
        {
          showBilledTo = true;
          const newServices = allServices?.filter(f => f.serviceBilledTo !== ServiceBilledTo.DocnoteDebit || f.serviceBilledTo === undefined);
          setServices(newServices);
        }
        break;
      default:
        setServices(allServices);
        break;
    }
    updated.forEach(item => {
      switch (item.id) {
        case "email":
          item.visible = email;
          if (!email) item.isValid = true;

          item.child?.forEach(child => {
            if (child.id === "phone") {
              child.visible = email;
            }
          });
          break;
        case "dateOfBirth":
          item.visible = dob;
          item.child?.forEach(child => {
            if (child.id === "ohipNumber") {
              child.visible = dob;
            }
          });
          break;
        case "recipientSection":
          item.visible = hideAdditionalCheck;
          break;
        case "recipientName":
          item.visible = false;
          item.value = "";
          item.isValid = false;
          item.child?.forEach(child => {
            if (child.id === "emailOrFax") {
              child.visible = false;
              child.value = "";
              child.isValid = false;
            }
          });
          break;
        case "recipientNameV2":
          item.visible = hideAdditionalCheck;
          item.value = "";
          item.isValid = false;
          item.child?.forEach(child => {
            if (child.id === "emailOrFaxNew") {
              child.visible = hideAdditionalCheck;
              child.value = "";
              child.isValid = false;
            }
          });
          break;
        case "pharmacySection":
          item.visible = pharmacy;
          break;
        case "pharmacyName":
          item.visible = pharmacy;
          item.value = "";
          item.isValid = false;
          item.child?.forEach(child => {
            if (child.id === "pharmacyEmailOrFax") {
              child.visible = pharmacy;
              child.value = "";
              child.isValid = false;
            }
          });
          break;
        case "addtionalCopyCheck":
          item.visible = email && dob && !hideAdditionalCheck;
          item.value = false;
          break;
        case "files":
          item.required = file;
          // For QuickFormOffice, files are only required if message is blank
          if (formType === NewRequestType.QuickFormOffice) {
            item.isValid = true; // Default to valid, validation will be handled in saveRequest
          } else {
            item.isValid = file && item.value ? true : !file;
          }
          break;
        case "billedto":
          item.visible = showBilledTo;
          item.isValid = billedToValue ? true : !((email && dob) || !email);
          item.value = billedToValue;
          break;
        default:
          break;
      }
    });
    setInputs(updated);
  }, [formType, allServices]);

  useEffect(() => {
    if (selectedPatient) {
      if (selectedPatient?.userId) {
        setSelectedPatientId(selectedPatient?.userId);
      }
      const keys = Object.keys(selectedPatient);
      const updated = [...inputs];
      const newInputs = updated.map(item => {
        const newItem = { ...item };
        // if (keys.includes(newItem.id)) newItem.value = selectedPatient[newItem.id];
        if (keys.includes(newItem.id) && newItem.id !== "note") newItem.value = selectedPatient[newItem.id];

        if (newItem.id === "firstName") {
          if (selectedPatient[newItem.id].length) {
            newItem.isValid = true;
          }
        }
        if (newItem.id === "email") {
          if (selectedPatient[newItem.id].length) {
            newItem.isValid = validateEmail(newItem.value as string);
          }
        }
        if (newItem.child && newItem.child?.length) {
          let newItemChild = [...newItem.child];
          newItemChild = newItemChild.map(child => {
            const newChild = { ...child };
            if (keys.includes(newChild.id)) newChild.value = selectedPatient[newChild.id];
            switch (newChild.id) {
              case "lastName":
                if (selectedPatient[newChild.id]?.length) {
                  newChild.isValid = true;
                }
                break;
              case "ohipNumber":
                if (selectedPatient[newChild.id]?.length) {
                  newChild.isValid = true;
                }
                break;
              case "phone":
                if (selectedPatient[newChild.id]?.length) {
                  newChild.value = formatPhoneNumber(newChild.value as string);
                  newChild.isValid = Phone_Fax_Regex.test(newChild.value);
                }
                break;
              default:
                break;
            }
            return newChild;
          });
          newItem.child = [...newItemChild];
        }
        return newItem;
      });

      setInputs(newInputs);
    }
  }, [selectedPatient]);

  useEffect(() => {
    localStorage.removeItem("additionalFee");
    dispatch(clearRequestData());
    if (id) {
      loadPatients(id);
      dispatch(listOfficeRequests({ officeId: id, page: 0, size: 100, sort: "createdDate,desc", assignedTo: "" })).then(() => {});
      dispatch(
        searchServiceData({
          officeId: id,
          page: 0,
          sort: "name",
          size: 200,
          enabledOnly: true,
          serviceOwner: ServiceOwner.Office,
        })
      );
    }
    return () => {
      dispatch(clearUploadedFiles());
    };
  }, []);

  useEffect(() => {
    if (id) {
      const officeId = id;
      dispatch(getOfficeUsersWithPermission({ officeId, permission: AuthPermission.Request, page: 0, sort: "", size: 100 }));
      dispatch(getOfficeCareProviders({ officeId }));
    }
  }, [id]);

  useEffect(() => {
    if (currentOffice === null && id) {
      dispatch(getOffice({ officeId: id }));
    }
    if (currentOffice?.officeId && currentOffice?.officeState !== OfficeState.Published) {
      navigate(`/offices/${currentOffice?.officeId}/requests`);
    }
  }, [currentOffice]);

  // Preselect patient in dropdown when reqData and patient list are available
  useEffect(() => {
    if (reqData?.contactPersonId && patientOptions?.length) {
      const match = patientOptions.find(p => p.userId === reqData.contactPersonId);
      if (match) {
        setSelectedPatient(match);
        setSelectedPatientId(match.userId);
      }
    }
  }, [reqData?.contactPersonId, patientOptions]);

  useEffect(() => {
    let newOptions = userWithPermission?.data?.content
      .filter(item => item.userState === "active")
      ?.map((user: User) => {
        let hasRequestPermission = false;
        if (user.permissions.includes(AuthPermission.Request)) {
          hasRequestPermission = true;
        }

        // then set has perm to true
        return { label: `${user.firstName} ${user.lastName}`, value: user.userId, requestPermission: hasRequestPermission };
      });
    newOptions = newOptions ? newOptions : [];
    setStaff(newOptions);
  }, [userWithPermission]);

  useEffect(() => {
    const pcpData = currentOffice?.primaryCareProviders;
    if (staff && pcpData && staff.length && pcpData.length) {
      const filteredStaff = pcpData.map(item => {
        const obj = staff.find(item1 => item.userState === UserState.Active && item.userId === item1.value);
        return obj;
      });
      if (filteredStaff && filteredStaff.length) {
        const currentstaff = staff.find(s => s.value === currentUser?.userId);
        if (currentstaff && currentstaff.value) {
          setOfficeStaff(currentstaff.value);
        } else {
          if (staff.length === 2 && filteredStaff.length === 1) {
            const stf = filteredStaff[0] && filteredStaff[0]["value"];
            if (stf) {
              const toBeSelect = staff.find(it => it.value !== stf);
              if (toBeSelect && toBeSelect.value) {
                setOfficeStaff(toBeSelect.value);
              }
            }
          } else if (filteredStaff.length === 1) {
            if (filteredStaff[0] && filteredStaff[0]["value"]) {
              setOfficeStaff(filteredStaff[0]["value"]);
            }
          }
        }
      }
    }
  }, [staff, currentOffice?.primaryCareProviders]);

  useEffect(() => {
    const pcpData = currentOffice?.primaryCareProviders;
    if (pcpData?.length) {
      const pcpList = pcpData?.filter(item => item.userState === UserState.Active);
      if (pcpList?.length === 1) {
        setCareProvider(pcpList[0].userId);
      }
    }
  }, [currentOffice?.primaryCareProviders]);

  useEffect(() => {
    if (!currentPermissions.includes(AuthPermission.Request)) {
      navigate(homeLink);
    }
  }, [currentPermissions]);

  useEffect(() => {
    if (!reqData) return;

    // Map contactPersonId -> patientId
    if (reqData.contactPersonId) {
      setSelectedPatientId(reqData.contactPersonId);
    }

    // Prefill top-level selections
    if (reqData.assignedToUserId) {
      setOfficeStaff(reqData.assignedToUserId);
    }

    // Prefill care provider once list is available by matching ID to option object (value expects JSON string)
    if (reqData.primaryCareProviderUserId && primaryCareProvider?.length) {
      const cp = primaryCareProvider.find(p => p.userId === reqData.primaryCareProviderUserId);
      if (cp) {
        setCareProvider(JSON.stringify(cp));
        setMpcNumber(cp.mpcNumber);
      }
    }

    // Prefill inputs values and validity
    setInputs(prev => {
      const updated = prev.map(item => {
        const newItem = { ...item } as any;
        const setValidity = (id: string, value: any): boolean => {
          const strValue = String(value || "").trim();
          switch (id) {
            case "email":
              return value ? validateEmail(String(value).trim()) : false;
            case "phone":
              return value ? Phone_Fax_Regex.test(formatPhoneNumber(String(value))) : false;
            case "dateOfBirth":
              return Boolean(value);
            case "ohipNumber":
              return String(value || "").length === 0 || String(value).length === 10;
            case "typeOfService":
              return Boolean(value);
            case "servicePrice":
              return Boolean(value);
            case "recipientName":
            case "recipientNameV2":
              return Boolean(value);
            case "emailOrFax":
            case "emailOrFaxNew":
            case "pharmacyEmailOrFax":
              return validateEmail(String(value).trim()) || validatePhoneOrFaxNumber(formatPhoneNumber(String(value).trim()));
            default:
              return Boolean(value);
          }
        };

        const assignValue = (id: string, value: any) => {
          // Assign value and validity to an input or its first child by id
          if (newItem.id === id) {
            newItem.value = value ?? newItem.value;
            newItem.isValid = setValidity(id, newItem.value);
          }
          if (newItem.child && newItem.child.length) {
            const child = { ...newItem.child[0] } as any;
            if (child.id === id) {
              child.value = value ?? child.value;
              child.isValid = setValidity(id, child.value);
              newItem.child = [{ ...child }];
            }
          }
        };

        // Map fields from reqData to inputs
        assignValue("firstName", reqData.firstName);
        assignValue("lastName", reqData.lastName);
        assignValue("email", reqData.email);
        assignValue("phone", reqData.phone);
        assignValue("dateOfBirth", reqData.dateOfBirth);
        assignValue("ohipNumber", reqData.ohipNumber);

        // Recipient block (supports V1 and V2 depending on form type)
        if (
          [NewRequestType.WSIBOffice, NewRequestType.ThirdPartyOffice, NewRequestType.ServiceCanadaOffice].includes(
            reqData.requestType as NewRequestType
          )
        ) {
          assignValue("recipientNameV2", reqData.recipientName);
          assignValue("emailOrFaxNew", reqData.recipientContact);
        } else if (reqData.requestType === NewRequestType.PrescriptionRefill) {
          assignValue("pharmacyName", reqData.recipientName);
          assignValue("pharmacyEmailOrFax", reqData.recipientContact);
        } else {
          assignValue("recipientName", reqData.recipientName);
          assignValue("emailOrFax", reqData.recipientContact);
        }
        // Auto-check Recipient (Optional) for StandardOffice when recipientName is present
        if (reqData.requestType === NewRequestType.StandardOffice && reqData.recipientName) {
          if (newItem.id === "addtionalCopyCheck") {
            newItem.visible = true;
            newItem.value = true;
            newItem.isValid = true;
          }
          if (newItem.id === "recipientName") {
            newItem.visible = true;
            newItem.isValid = setValidity("recipientName", newItem.value);
            if (newItem.child && newItem.child.length) {
              const child = { ...newItem.child[0] } as any;
              if (child.id === "emailOrFax") {
                child.visible = true;
                child.isValid = setValidity("emailOrFax", child.value);
                newItem.child = [{ ...child }];
              }
            }
          }
        }

        // Auto-check Recipient (Optional) for StandardOffice when recipientName is present
        if (reqData.requestType === NewRequestType.StandardOffice && reqData.recipientName) {
          if (newItem.id === "addtionalCopyCheck") {
            newItem.visible = true;
            newItem.value = true;
            newItem.isValid = true;
          }
          if (newItem.id === "recipientName") {
            newItem.visible = true;
            newItem.isValid = setValidity("recipientName", newItem.value);
            if (newItem.child && newItem.child.length) {
              const child = { ...newItem.child[0] } as any;
              if (child.id === "emailOrFax") {
                child.visible = true;
                child.isValid = setValidity("emailOrFax", child.value);
                newItem.child = [{ ...child }];
              }
            }
          }
        }

        // Auto-check Recipient (Optional) for StandardOffice when recipientName is present
        if (reqData.requestType === NewRequestType.StandardOffice && reqData.recipientName) {
          if (newItem.id === "addtionalCopyCheck") {
            newItem.visible = true;
            newItem.value = true;
            newItem.isValid = true;
          }
          if (newItem.id === "recipientName") {
            newItem.visible = true;
            newItem.isValid = setValidity("recipientName", newItem.value);
            if (newItem.child && newItem.child.length) {
              const child = { ...newItem.child[0] } as any;
              if (child.id === "emailOrFax") {
                child.visible = true;
                child.isValid = setValidity("emailOrFax", child.value);
                newItem.child = [{ ...child }];
              }
            }
          }
        }

        // Service selection + price override
        if (reqData.serviceId) {
          assignValue("typeOfService", reqData.serviceId);
        }
        if (reqData.servicePriceOverride !== undefined && reqData.servicePriceOverride !== null) {
          const formatted = formatCurrency(String((reqData.servicePriceOverride / 100).toFixed(2)), "blur");
          assignValue("servicePrice", formatted);
        }

        return newItem;
      });
      return updated;
    });

    // Keep local service and discount states in sync
    if (reqData.serviceId && services?.length) {
      const svc = services.find(s => s.serviceId === reqData.serviceId);
      setSelectedService(svc);
    }
    if (reqData.discountType) {
      setDiscountType(reqData.discountType);
      setDiscountAmount(reqData.discountAmount || 0);
      if (reqData.discountType === RequestDiscountType.Amount) {
        setDiscountValue(reqData.discountAmount ? formatCurrency(String(((reqData.discountAmount || 0) / 100).toFixed(2)), "blur") : "");
      } else {
        setDiscountValue(reqData.discountAmount ? String(reqData.discountAmount) : "");
      }
      setDiscountError(false);
    }
  }, [reqData, primaryCareProvider, services]);

  const handleBlur = (id: string) => {
    const updated = [...inputs];
    setInputs(updated);
  };

  const handleFormType = async (val: NewRequestType) => {
    setFormType(val);
    setSelectedContact(undefined);
    setContactMethod(ContactMethodType.Email);
    setFilesValidationError(false);
    handleChange("typeOfService", "");
    if (val === NewRequestType.PrescriptionRefill && id) {
      await fetchContacts(id, "Pharmacy", "");
    } else if (id) {
      await fetchContacts(id);
    }
  };

  const handleChange = (id: string, _value: string | boolean) => {
    if (id === "total") return;
    let tempInput = [...inputs];
    const inputIndex = tempInput.findIndex(a => a.id === id);
    let value = _value;
    let valid = value !== "";

    // Reset files validation when files are added for QuickFormOffice
    if (id === "files" && formType === NewRequestType.QuickFormOffice && value && value !== "") {
      const filesInputIndex = tempInput.findIndex(a => a.id === "files");
      if (filesInputIndex !== -1) {
        tempInput[filesInputIndex].isValid = true;
      }
      setFilesValidationError(false);
    }
    switch (id) {
      case "phone":
        value = formatPhoneNumber(value as string);
        valid = Phone_Fax_Regex.test(value);
        break;
      case "ohipNumber":
        if ((value as string).trim().length > 0) {
          valid = (value as string).length ? (value as string).length === 10 : true;
        } else {
          valid = true;
        }
        break;
      case "email":
        isEmailChange = true;
        valid = validateEmail((value as string).trim());
        break;
      case "note":
        if ((value as string).length > 50) {
          setServiceNotesError(true);
        } else {
          setServiceNotesError(false);
          setServiceNotesValue(value as string);
        }
        break;
      case "details":
        if (typeof value === "string") {
          // Max 1000 characters allowed for request details
          valid = (value as string).length <= 1000;
        }
        break;
      case "typeOfService":
        setDiscountAmount(0);
        setDiscountValue("");
        const billedToIs = services?.find(ele => ele.serviceId === value);
        setSelectedService(billedToIs);
        if (tempInput[inputIndex] && tempInput[inputIndex].child) {
          const newItem = { ...tempInput[inputIndex] };
          if (newItem.child && newItem.child?.length) {
            let newChild = [...newItem.child];
            const newChildItem = { ...newChild[0] };
            newChild = [
              ...newChild.slice(0, 0),
              {
                ...newChildItem,
                value: formatCurrency((services?.find(v => v.serviceId === value)?.price! / 100).toString() || "", "blur"),
                isValid: formatCurrency((services?.find(v => v.serviceId === value)?.price! / 100).toString() || "", "blur").length > 0,
              },
              ...newChild.slice(1),
            ];
            tempInput = [...tempInput.slice(0, inputIndex), { ...newItem, child: [...newChild] }, ...tempInput.slice(inputIndex + 1)];
          }
        }
        const billToIndex = tempInput.findIndex(itm => itm.id === "billedto");
        if (billToIndex !== -1 && billedToIs?.serviceBilledTo) {
          const newItem = { ...tempInput[billToIndex] };
          tempInput = [
            ...tempInput.slice(0, billToIndex),
            { ...newItem, value: billedToIs.serviceBilledTo, isValid: true },
            ...tempInput.slice(billToIndex + 1),
          ];
        }
        break;
      case "addtionalCopyCheck":
        const toChange = ["consentForExtraCopy", "emailOrFax", "recipientName"];
        if (value === true) {
          tempInput.forEach(val => {
            if (val.id === toChange[2]) {
              val.visible = true;
              val.child![0].visible = true;
            }
            if (val.id === toChange[0]) {
              val.visible = true;
              val.isValid = false;
            }
          });
        } else {
          setSelectedContact(undefined);
          tempInput.forEach(val => {
            if (val.id === toChange[2]) {
              val.visible = false;
              val.child![0].visible = false;
              val.value = "";
              val.child![0].value = "";
              val.child![0].isValid = false;
              val.isValid = false;
            }
            if (val.id === toChange[0]) {
              val.visible = false;
              val.value = false;
              val.isValid = false;
            }
          });
        }
        break;
      case "consentForExtraCopy":
        valid = value as boolean;
        tempInput[inputIndex].isValid = value as boolean;
        break;
      case "emailOrFax":
      case "emailOrFaxNew":
      case "pharmacyEmailOrFax":
        if (validateEmail((value as string).trim())) {
          valid = true;
        } else if (validatePhoneOrFaxNumber(formatPhoneNumber(value as string))) {
          value = formatPhoneNumber(value as string);
          valid = true;
        } else {
          valid = false;
        }
        break;
      case "servicePrice":
        value = formatCurrency(value as string, "");
        valid = value !== "";
        break;
      default:
        break;
    }
    if (inputIndex === -1) {
      let newInputs = [...tempInput];
      tempInput.forEach((val, i, arr) => {
        const newItem = { ...val };
        if (newItem.child && newItem.child[0].id === id) {
          let newChilds = [...newItem.child];
          newChilds = [...newChilds.slice(0, 0), { ...newChilds[0], value: value, isValid: valid }, ...newChilds.slice(1)];
          newInputs = [...newInputs.slice(0, i), { ...newInputs[i], child: [...newChilds] }, ...newInputs.slice(i + 1)];
        }
      });
      setInputs(newInputs);
      return;
    }

    setInputs([
      ...tempInput.slice(0, inputIndex),
      {
        ...tempInput[inputIndex],
        value: value,
        isValid: valid,
      },
      ...tempInput.slice(inputIndex + 1),
    ]);
  };

  const isOfficeType = (formType?: NewRequestType | undefined) =>
    !!formType &&
    [
      // Ensure formType is defined before checking
      NewRequestType.StandardOffice,
      NewRequestType.ThirdPartyOffice,
      NewRequestType.WSIBOffice,
      NewRequestType.ServiceCanadaOffice,
      NewRequestType.QuickFormOffice,
      NewRequestType.PrescriptionRefill,
      NewRequestType.DocnoteDebit,
    ].includes(formType);

  const validateForm = () => {
    if (serviceNotesError) {
      return false;
    }
    return (
      !!formType &&
      inputs
        .map(v => {
          if (v.visible === false) return true;
          // Even though "details" is not required, we still want to enforce its max-length validation
          if (v.id === "details") return v.isValid;
          if (v.required === false) return true;
          if (v.child) {
            return [v.child[0].isValid, v.isValid].every(v => v);
          }
          return v.isValid;
        })
        .every(v => v) &&
      (!isOfficeType(formType) || (officeStaff && careProvider)) // Ensure officeStaff & careProvider exist if required
    );
  };

  const renderInput = (inp: InputsTypes) => {
    if (inp.visible === false) return null;
    const isLocked = Boolean(lockedFromPrefill[inp.id as keyof typeof lockedFromPrefill]);
    return (
      <div key={inp.id} className={`${inp.visible ? "py-2" : ""} ${inp.width === "half" ? "w-full sm:w-1/2" : "w-full"}`}>
        {(() => {
          switch (inp.type) {
            case "textInput":
              return (
                <TextInput
                  onChangeFunc={e => handleChange(inp.id, e.currentTarget.value)}
                  disabled={isLocked || inp.id === "servicePrice"}
                  placeholder={inp.placeholder}
                  value={typeof inp.value === "string" ? inp.value : ""}
                  errorMsg={inp.errorMesage}
                  isRequired={inp.required}
                  label={inp.title}
                  key={inp.id}
                  isError={!inp.isValid && errorInitiated}
                  extraInputClass={""}
                  onBlur={e => {
                    handleBlur(inp.id);
                    handleChange(inp.id, e.target.value.trim());
                  }}
                />
              );
            case "typeOfService":
              return (
                <div key={inp.id} className="select-service">
                  <SelectWithSearch
                    value={inp.value as string}
                    onSearcSelect={newalue => {
                      setselectSearch(newalue);
                    }}
                    onSelect={newValue => {
                      handleChange(inp.id, newValue.serviceId);
                    }}
                    options={services?.filter(o => o.name.toLowerCase().includes(selectsearch.toLowerCase())) || []}
                    label={inp.title}
                    required={inp.required}
                    placeholder={"Select Service"}
                    isSearchBox={true}
                    searchValue={selectsearch}
                    renderOption={option => {
                      return option.name;
                    }}
                    renderValue={option => {
                      return services?.find(o => o.serviceId === option)?.name;
                    }}
                    onSearchChange={(e, newValue) => {
                      setselectSearch(newValue);
                    }}
                  />
                  {!inp.isValid && errorInitiated ? <p style={{ color: colors.Red }}>{inp.errorMesage}</p> : null}
                </div>
              );
            case "billedto":
              return (
                <div className="block sm:flex justify-between items-center">
                  <label className="text-sm text-docsigna-blue-dark font-medium block w-half mb-1">
                    {inp.title}
                    {inp.required ? <span className="text-red-500">*</span> : null}
                  </label>{" "}
                  <div className="w-full sm:w-48">
                    <select
                      onChange={e => handleChange(inp.id, e.currentTarget.value)}
                      value={inp.value as string}
                      className="general-select w-full"
                      disabled={
                        formType
                          ? [NewRequestType.ThirdPartyOffice, NewRequestType.WSIBOffice, NewRequestType.ServiceCanadaOffice].includes(formType)
                          : false
                      }
                    >
                      {formType === NewRequestType.StandardOffice || !formType ? <option hidden>Select billed to</option> : null}
                      {finalServiceBilled?.map((ser: any) => {
                        return (
                          <option value={ser.id} key={ser.id}>
                            {ser.name}
                          </option>
                        );
                      })}
                    </select>
                    <div>{!inp.isValid && errorInitiated ? <FormErrorMessage text={inp?.errorMesage ? inp?.errorMesage : ""} /> : null}</div>
                  </div>
                </div>
              );
            case "staff":
              return (
                <div>
                  <label className="text-sm font-medium block w-full mb-1">
                    {inp.title}
                    <span className="text-red-500">*</span>
                  </label>
                  <select onChange={e => handleStaffChange(e.currentTarget.value)} value={officeStaff} className="general-select w-full">
                    {staff.length === 1 ? null : <option hidden>Select Staff</option>}
                    {staff.map((staf: any) => {
                      return (
                        <option value={staf.value} key={staf.value}>
                          {staf.label}
                        </option>
                      );
                    })}
                  </select>
                  <div>{!officeStaff && errorInitiated ? <FormErrorMessage text={inp?.errorMesage || ""} /> : null}</div>
                </div>
              );
            case "primarycareprovider":
              return (
                <div>
                  <label className="text-sm font-medium  block w-full mb-1">
                    {inp.title}
                    <span className="text-red-500">*</span>
                  </label>
                  {/* <select onChange={e => handleCareProvider(e.currentTarget.value, e)} value={careProvider} className="general-select w-full">
                    {currentOffice?.primaryCareProviders?.length === 1 ? null : <option>Select Care Provider</option>}
                    {currentOffice?.primaryCareProviders
                      ?.filter(care => care.userState === "active")
                      .map(care => {
                        return (
                          <option value={care.userId} key={care.userId}>
                            {`${care.firstName} ${care.lastName}`}
                          </option>
                        );
                      })}
                  </select> */}
                  <select
                    // onChange={e => handleCareProvider(JSON.parse(e.currentTarget.value))}
                    onChange={e => handleCareProvider(e.currentTarget.value)}
                    value={careProvider}
                    className="general-select w-full"
                  >
                    <option value="">Select Care Provider</option>
                    {primaryCareProvider
                      ?.filter(care => care.userState === "active")
                      .map(care => (
                        <option value={JSON.stringify(care)} key={care.userId}>
                          {`${care.firstName} ${care.lastName}`}
                        </option>
                      ))}
                  </select>
                  <div>{!careProvider && errorInitiated ? <FormErrorMessage text={inp?.errorMesage || ""} /> : null}</div>
                </div>
              );
            case "SectionTitle":
              return (
                <div>
                  <p key={inp.id} className="text-base mb-1">
                    <span className="block text-base font-bold">{inp.title}</span>
                  </p>
                  {inp.subTitle ? <p className="text-base mb-2">{inp.subTitle}</p> : null}
                </div>
              );
            case "textArea":
              return (
                <TextInput
                  onChangeFunc={e => handleChange(inp.id, e.currentTarget.value)}
                  placeholder={inp.placeholder}
                  value={typeof inp.value === "string" ? inp.value : ""}
                  errorMsg={inp.errorMesage}
                  isRequired={inp.required}
                  label={inp.title}
                  key={inp.id}
                  isTextArea
                  isError={!inp.isValid && errorInitiated}
                  extraInputClass="resize-none"
                />
              );
            case "serviceNotes":
              return (
                <TextInput
                  onChangeFunc={e => handleChange(inp.id, e.currentTarget.value)}
                  placeholder={inp.placeholder}
                  value={serviceNotesValue}
                  errorMsg={inp.errorMesage}
                  isRequired={inp.required}
                  label={inp.title}
                  key={inp.id}
                  isTextArea
                  isError={errorInitiated && serviceNotesError}
                  showCounter={true}
                  counterMessage={"50"}
                  extraInputClass="resize-none"
                />
              );
            case "DropArea":
              return formType !== NewRequestType.DocnoteDebit ? (
                <div id="attachment-section">
                  {formType === NewRequestType.QuickFormOffice && pssData?.officePss ? (
                    <TextInput
                      onChangeFunc={e => {
                        const val = e.currentTarget.value;
                        setMessageValue(val);
                        // Reset files validation error when message is entered
                        if (val.trim().length > 0) {
                          setFilesValidationError(false);
                          // Also mark files input as valid so the error hides immediately
                          setInputs(prev => prev.map(input => (input.id === "files" ? { ...input, isValid: true } : input)));
                        }
                      }}
                      placeholder={"Patient letter Content"}
                      value={messageValue}
                      errorMsg={"Enter Message is required"}
                      isRequired={false}
                      subLabel={"Please enter patient letter and/or attachment"}
                      label={"Patient letter Content"}
                      key={`message-field`}
                      isTextArea
                      isError={false}
                      extraInputClass="resize-none mb-4"
                    />
                  ) : null}
                  <p className="text-base mb-2">
                    <span className="block text-base  font-bold">
                      {formType === NewRequestType.StandardOffice ||
                      formType === NewRequestType.ThirdPartyOffice ||
                      formType === NewRequestType.WSIBOffice ||
                      formType === NewRequestType.ServiceCanadaOffice ||
                      formType === NewRequestType.QuickFormOffice
                        ? "Attachments"
                        : formType === NewRequestType.PrescriptionRefill
                        ? "Prescription Renewal Document"
                        : "Final Document(s)"}
                      {formType === NewRequestType.PrescriptionRefill || (formType === NewRequestType.QuickFormOffice && !pssData?.officePss) ? (
                        <span className="text-red-500">*</span>
                      ) : null}
                    </span>{" "}
                    <p>You can attach up to {maxNumOfFilesUpload} JPEG, PDF, XLSX, Docx or PNG files</p>
                  </p>
                  <DropArea
                    allowedFileTypes={[FileTypes.JPEG, FileTypes.PNG, FileTypes.PDF, FileTypes.XLSX, FileTypes.DOCX]}
                    onFilesChange={files => handleChange(inp.id, files.toString())}
                    onError={err => setDropAreaError(onFileError(err))}
                    maxFileSize={50 * 1024 * 1024}
                    maxNumOfFiles={maxNumOfFilesUpload}
                    filePreviewVisible={true}
                  />
                  <p className="text-red-500">
                    {filesValidationError && formType === NewRequestType.QuickFormOffice
                      ? "Attachment is required."
                      : !inp.isValid && errorInitiated
                      ? inp.errorMesage
                      : null}
                  </p>
                  {dropAreaError ? <p className="text-red-500">{dropAreaError}</p> : null}
                </div>
              ) : (
                <div />
              );
            case "checkbox":
              return (
                <>
                  {inp.id === "addtionalCopyCheck" ? (
                    <p className="text-base mb-2">
                      <span className="block text-base  font-bold mb-1">Recipient</span>
                    </p>
                  ) : null}
                  <Checkbox
                    label={inp.title}
                    checked={typeof inp.value === "boolean" ? inp.value : false}
                    key={inp.id}
                    onChange={e => handleChange(inp.id, e.currentTarget.checked)}
                  />
                  {!inp.isValid && errorInitiated ? <p style={{ color: colors.Red }}>{inp.errorMesage}</p> : null}
                </>
              );
            case "dateOfBirth":
              return (
                <div className="create-request-screen mb-1">
                  <DatePicker
                    label={inp.title}
                    isRequired={inp.required}
                    name={inp.id}
                    placeholder={inp.placeholder!}
                    value={inp.value as string}
                    onChange={val => handleChange(inp.id, val)}
                    errorMsg={inp.errorMesage}
                    isError={!inp.isValid && errorInitiated}
                    disabled={Boolean(lockedFromPrefill[inp.id as keyof typeof lockedFromPrefill])}
                  />
                </div>
              );
            case "ohip":
              return (
                <div>
                  <label className="text-sm text-docsigna-blue-dark font-medium block w-full mb-1">
                    {inp.title}
                    {inp.required ? <span className="text-red-500">*</span> : null}
                  </label>
                  {/* Hidden honeypot field to confuse browser autofill */}
                  <input type="text" name="cc-number" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />
                  <NumberFormat
                    value={inp.value as string}
                    isNumericString
                    format={"#### ### ###"}
                    placeholder="Health Card #"
                    displayType="input"
                    inputMode="numeric"
                    name={`hc_${Date.now()}`}
                    id="provincial-health-id"
                    autoComplete="one-time-code"
                    data-form-type="other"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    aria-autocomplete="none"
                    className="general-ohip"
                    onValueChange={values => {
                      handleChange(inp.id, values.value);
                    }}
                    disabled={Boolean(lockedFromPrefill["ohipNumber"]) || Boolean(lockedFromPrefill[inp.id as keyof typeof lockedFromPrefill])}
                  />
                  {!inp.isValid && errorInitiated ? <p style={{ color: colors.Red }}>{inp.errorMesage}</p> : null}
                </div>
              );
            case "select":
              return (
                <>
                  <Select
                    required
                    placeHolder={inp.placeholder!}
                    title={inp.title}
                    onSelect={e => handleChange(inp.id, e.currentTarget.value)}
                    options={["Option 1", "Option 2", "Option 3"]}
                  />
                  {!inp.isValid && errorInitiated ? <p style={{ color: colors.Red }}>{inp.errorMesage}</p> : null}
                </>
              );
            default:
              return <div />;
          }
        })()}
      </div>
    );
  };

  const renderChildInput = (inp: InputsTypes) => {
    const isPharmacyNameInput = inp.id === "pharmacyName";
    const isRecipientOrPharmacyNameInput = inp.id === "recipientName" || inp.id === "recipientNameV2" || isPharmacyNameInput;

    const isOfficeContactPharmacy = (officeContact: Contact) => officeContact?.contactType === "Pharmacy";
    const doesOfficeContactCompanyMatchSearchQuery = (officeContact: Contact) =>
      `${officeContact?.company?.toLowerCase()}`.includes(selectedContactsearch.toLowerCase());
    const filterOfficeContacts = (officeContact: Contact) =>
      (!isPharmacyNameInput || isOfficeContactPharmacy(officeContact)) && doesOfficeContactCompanyMatchSearchQuery(officeContact);

    const formatAddress = (contact: Contact): string => {
      const addressParts = [contact?.street1, contact?.street2, contact?.city, contact?.province, contact?.postalCode].filter(Boolean);

      return addressParts.join(", ");
    };

    // Helper function to truncate text with ellipsis
    const truncateText = (text: string, maxLength: number): string => {
      if (text?.length <= maxLength) return text;
      return text?.substring(0, maxLength) + "...";
    };

    return (
      <>
        {inp.visible && isRecipientOrPharmacyNameInput ? (
          <>
            <SelectWithBackendSearch
              value={selectedContact?.company ? `${selectedContact?.company}` : ""}
              onSelect={(option: any) => onContactOptionSelect(option)}
              options={officeContacts || []}
              placeholder={"Select Company"}
              searchValue={selectedContactsearch}
              onSearchChange={(e, newValue) => setSelectContactSearch(newValue)}
              // renderOption={option => <div>{option.company}</div>}
              renderOption={(option: Contact) => (
                <div className="flex justify-between items-center">
                  {/* Left side - Company name */}
                  <div className="flex-1 min-w-0 mr-2">
                    <span className="font-medium text-docsigna-blue-dark">{option?.company || "N/A"}</span>
                  </div>
                  {/* Right side - Address with truncation */}
                  <div className="flex-1 min-w-0 text-right">
                    <span className="text-docsigna-blue-dark text-sm">{truncateText(formatAddress(option), 40)}</span>
                  </div>
                </div>
              )}
              renderValue={option => {
                const renderVal = officeContacts?.find(o => `${o?.company}` === option);
                return renderVal ? `${renderVal?.company}` : "";
              }}
            />
            {selectedContact ? (
              <>
                <p className="mt-2">Select method for sending final document:</p>
                <div className="w-full sm:w-1/3 flex">
                  <label className="block w-auto sm:w-full mb-1 mr-4 sm:mr-0 relative">
                    <input
                      type={"radio"}
                      checked={selectedContactMethod === ContactMethodType.Email}
                      value={ContactMethodType.Email}
                      onChange={e => handleContactMethod(e.currentTarget.value as ContactMethodType)}
                      className="general-radio bg-transparent"
                    />
                    <span className="text-base ml-2">Email</span>
                  </label>
                  <label className="block w-auto sm:w-full mb-1 relative">
                    <input
                      type={"radio"}
                      checked={selectedContactMethod === ContactMethodType.Fax}
                      value={ContactMethodType.Fax}
                      onChange={e => handleContactMethod(e.currentTarget.value as ContactMethodType)}
                      className="general-radio bg-transparent"
                    />
                    <span className="text-base ml-2">Fax</span>
                  </label>
                </div>
              </>
            ) : null}
          </>
        ) : null}
        <div className="w-full flex gap-6" key={inp.id}>
          {renderInput(inp)}
          {inp?.child?.map(ch => {
            return renderInput(ch);
          })}
        </div>
      </>
    );
  };

  const handleAddAdditionalSideBar = () => {
    setAddSideBarOpen(true);
  };

  const handleStaffChange = (e: string) => {
    setOfficeStaff(e);
  };
  const handleCareProvider = (e: string) => {
    let val = e;
    if (e === "Select Care Provider") {
      val = "";
    }
    setCareProvider(val);
    if (primaryCareProvider) {
      const selectedCare = primaryCareProvider.find(item => item.userId === JSON.parse(val).userId);
      setMpcNumber(selectedCare?.mpcNumber);
    }
  };

  const saveRequest = async () => {
    // Prevent multiple simultaneous calls
    if (isSubmitting) {
      return;
    }

    if (currentOffice?.officeId) {
      setIsSubmitting(true);
      try {
        // Check if QuickFormOffice and message is blank, then validate attachments
        if (formType === NewRequestType.QuickFormOffice && messageValue.trim().length === 0) {
          const filesInput = inputs.find(f => f.id === "files");
          if (filesInput && (!filesInput.value || filesInput.value === "")) {
            // Update the files input validation state to show error
            const updatedInputs = inputs.map(input => {
              if (input.id === "files") {
                return { ...input, isValid: false };
              }
              return input;
            });
            setInputs(updatedInputs);
            setFilesValidationError(true);
            setErrorInitiated(true);

            // Scroll to attachment section when validation error occurs
            setTimeout(() => {
              const attachmentSection = document.getElementById("attachment-section");
              if (attachmentSection) {
                attachmentSection.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }, 100);

            setIsSubmitting(false);
            return;
          }
        }

        let userData = null;
        if (isEmailChange && email && selectedPatient?.email !== email) {
          const res: any = await dispatch(
            searchOfficeUser({
              officeId: currentOffice.officeId,
              term: email,
              sortType: "lastName,asc",
              page: 0,
              size: 200,
              userType: UserType.Patient,
            })
          );
          if (res?.payload && res?.payload?.data && res?.payload?.data?.content?.length) {
            userData = res?.payload?.data?.content[0];
            if (userData?.userState === UserState.Active) {
              setSearchedUserData(userData);
              setIsSubmitting(false);
            } else {
              await addReq(false, userData?.userId);
              setIsSubmitting(false);
            }
            return;
          } else {
            if (
              formType &&
              ![NewRequestType.DocnoteDebit, NewRequestType.ThirdPartyOffice, NewRequestType.WSIBOffice, NewRequestType.ServiceCanadaOffice].includes(
                formType
              )
            ) {
              setShowPatientInviteDialog(true);
              setIsSubmitting(false);
              return;
            }
          }
        }
        await addReq();
        setIsSubmitting(false);
      } catch (error) {
        setIsSubmitting(false);
      }
    }
  };
  function getValidCareProvider(careProvider: any): string | undefined {
    if (!careProvider) return undefined;

    try {
      const parsed = JSON.parse(careProvider);
      return parsed?.userId ?? undefined;
    } catch {
      return careProvider; // already a userId string
    }
  }

  const addReq = async (useSearchedData = false, userId?: string) => {
    if (currentOffice?.officeId) {
      const requestFormType = formType === NewRequestType.QuickFormOffice;
      let patientId;
      if (!useSearchedData && userId) {
        patientId = userId;
      } else {
        patientId =
          useSearchedData && searchedUserData?.userId
            ? searchedUserData?.userId
            : selectedPatientId && isEmailChange && email !== selectedPatient?.email
            ? undefined
            : selectedPatientId;
      }
      if (formType) {
        const isOfficePss = Boolean(pssData?.officePss);

        const actionCreator = isOfficePss && formType === NewRequestType.QuickFormOffice && messageValue.length ? addRequestNote : addRequest;

        const validCareprovider = getValidCareProvider(careProvider);
        const requestBody = {
          requestType: formType,
          firstName: useSearchedData && searchedUserData?.firstName ? searchedUserData?.firstName : firstName,
          lastName: useSearchedData && searchedUserData?.lastName ? searchedUserData?.lastName : lastName,
          dateOfBirth: useSearchedData && searchedUserData?.dateOfBirth ? searchedUserData?.dateOfBirth : birthday === "" ? undefined : birthday,
          ohipNumber: useSearchedData && searchedUserData?.ohipNumber ? searchedUserData?.ohipNumber : ohipNumber === "" ? undefined : ohipNumber,
          phone: useSearchedData && searchedUserData?.phone ? searchedUserData?.phone : phoneNumber === "" ? undefined : phoneNumber,
          email: email?.trim() ? email.trim() : undefined,
          details: details === "" ? undefined : details,
          fileIds: requestFormType ? undefined : newFiles.length ? newFiles : undefined,
          recipientName: recipientName === "" ? undefined : recipientName.trim(),
          recipientContact: recipientContact === "" ? undefined : recipientContact.trim(),
          officeId: currentOffice?.officeId,
          patientId: patientId,
          fulfillOnPayment: requestFormType ? true : undefined,
          assignedToUserId: officeStaff ? officeStaff : undefined,
          primaryCareProviderUserId: validCareprovider,
          serviceId: typeOfService as string,
          serviceBilledToOverride: billedToSent,
          servicePriceOverride: parseFloat(servicePriceOverride.replace("$", "").replaceAll(",", "")) * 100,
          serviceNotes: serviceNotes && serviceNotes.length ? serviceNotes.trim() : undefined,
          message: formType === NewRequestType.QuickFormOffice && messageValue.length ? messageValue.trim() : undefined,
          mpcNumber: formType === NewRequestType.QuickFormOffice && mpcNumber ? mpcNumber : undefined,
          finalFileIds: requestFormType ? (newFiles.length ? newFiles : []) : undefined,
          patientVerified: true,
          fees: additionalFees,
          discountAmount: discountAmount,
          discountType: discountType,
          requestSourceId: reqData?.requestSourceId ? reqData?.requestSourceId : undefined,
        };
        if (windowObj && windowObj?.userGuiding && windowObj?.userGuiding?.launchSurvey) {
          windowObj?.userGuiding?.launchSurvey(3152);
        }
        try {
          const action = await dispatch(actionCreator({ request: requestBody }));
          if (action.payload !== null) {
            const responseData = JSON.stringify(action?.payload);
            const responseParse = JSON.parse(responseData);
            if (responseParse && responseParse.status === 409) {
              setAddRequestError(true);
              setErrorMessage(responseParse?.message);
            } else {
              dispatch(clearUploadedFiles());
              if (!useSearchedData && userId) {
                sessionStorage.setItem(SESSION_STORAGE_NEW_REQUEST, responseParse?.requestId);
              }
              if (responseParse?.message) {
                toast?.openToast(responseParse?.message, 2000, ToastVariants.Error);
              } else {
                const requestID = responseParse?.requestId ? responseParse?.requestId : responseData.replace(/"/g, "");
                navigate(`/offices/${currentOffice?.officeId}/requests/${requestID}`);
              }
            }
          }
          setSearchedUserData(null);
        } catch (error) {
          // Error handling if needed
        }
      }
    }
  };
  const updateRecipients = (contact: Contact, val: ContactMethodType) => {
    let fieldName = "recipientName";
    switch (formType) {
      case NewRequestType.ThirdPartyOffice:
      case NewRequestType.ServiceCanadaOffice:
      case NewRequestType.WSIBOffice:
        fieldName = "recipientNameV2";
        break;
      case NewRequestType.PrescriptionRefill:
        fieldName = "pharmacyName";
        break;
      default:
        break;
    }
    const index = inputs.findIndex(inp => inp.id === fieldName);
    if (index !== -1) {
      const oldInp = inputs[index];
      const child = oldInp.child;
      if (child) {
        child[0].value = val === ContactMethodType.Email ? contact.email ?? "" : contact.fax ?? "";
        child[0].isValid = (val === ContactMethodType.Email && contact.email) || (val === ContactMethodType.Fax && contact.fax) ? true : false;
      }
      const newItem = { ...oldInp, value: `${contact?.company ?? ""}`, isValid: true, child };
      setInputs([...inputs.slice(0, index), { ...newItem }, ...inputs.slice(index + 1)]);
    }
  };

  const handleContactMethod = (val: ContactMethodType) => {
    setContactMethod(val);
    if (selectedContact) {
      updateRecipients(selectedContact, val);
    }
  };

  const onOptionSelect = (patientData: any) => {
    isEmailChange = false;
    setSelectedPatient(patientData);
    setselectPatientSearch("");
  };

  const debounced = useDebouncedCallback(value => {
    setDiscountAmount(value);
  }, 750);

  const onContactOptionSelect = (contact: Contact) => {
    setSelectedContact(contact);
    setSelectContactSearch("");
    const newContactMethod =
      contact?.contactPreference && contact?.contactPreference !== "Phone"
        ? (contact?.contactPreference as ContactMethodType)
        : selectedContactMethod;
    setContactMethod(newContactMethod);
    updateRecipients(contact, newContactMethod);
  };

  const handleDiscount = (type: "$" | "%" | "input", value: string | boolean) => {
    switch (type) {
      case "$":
      case "%":
        setDiscountType(type === "$" ? RequestDiscountType.Amount : RequestDiscountType.Percentage);
        setDiscountAmount(0);
        setDiscountValue("");
        setDiscountError(false);
        break;
      case "input":
        switch (discountType) {
          case RequestDiscountType.Amount:
            const amount = formatCurrency(value as string, "");
            setDiscountValue(amount);
            const amnt = +amount.replace(AmountReplaceRegex, "") * 100;
            if (selectedService?.price && amnt > selectedService?.price) {
              setDiscountError(true);
            } else {
              setDiscountError(false);
            }
            debounced(parseFloat(amnt.toFixed(2)));
            break;
          case RequestDiscountType.Percentage:
            const discount = +parseInt((value as string).replace(DiscountValueRegex, "")).toFixed(2) || 0;
            if (discount <= 100) {
              setDiscountValue(discount ? (value as string).replace(DiscountValueRegex, "") : "");
              debounced(discount);
            }
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };

  const handleDiscountBlur = () => {
    if (discountAmount && discountType === RequestDiscountType.Amount) {
      setDiscountValue(formatCurrency((discountAmount / 100)?.toString(), "blur"));
    }
  };

  const getUserData = () => {
    return (
      <div>
        <h2 className="font-bold">This patient has an existing account with the below details:</h2>
        <div className="grid grid-cols-1 gap-2 mt-3 mb-3">
          <div>
            <span className="font-semibold mr-2">Name:</span>
            {searchedUserData?.firstName} {searchedUserData?.lastName}
          </div>
          <div>
            <span className="font-semibold mr-2">Health Card Number:</span>
            {searchedUserData?.ohipNumber ? searchedUserData?.ohipNumber : "-"}
          </div>
          <div>
            <span className="font-semibold mr-2">Date of Birth:</span>
            {searchedUserData?.dateOfBirth ? moment(searchedUserData?.dateOfBirth).format("ll") : "-"}
          </div>
          <div>
            <span className="font-semibold mr-2">Email:</span>
            <a
              href={`mailto:${searchedUserData?.email}`}
              className="cursor-pointer hover:underline text-docsigna-blue-dark"
              onClick={e => e.stopPropagation()}
            >
              {searchedUserData?.email}
            </a>
          </div>
          <div>
            <span className="font-semibold mr-2">Phone #:</span>
            {searchedUserData?.phone ? searchedUserData?.phone : "-"}
          </div>
        </div>
        <h2 className="">Would you like to proceed using their account? Please click No to continue as a guest request.</h2>
        <div className="flex justify-end">
          <div className="w-40 flex justify-between mt-5">
            <Button onClick={() => setSearchedUserData(null)} text="No" variant={"Secondary"} className="" />
            <Button
              onClick={async () => {
                setIsSubmitting(true);
                try {
                  await addReq(true);
                } finally {
                  setIsSubmitting(false);
                }
              }}
              text="Proceed"
              variant={"Primary"}
              className="border"
            />
          </div>
        </div>
      </div>
    );
  };

  const fetchContacts = async (id: string, contactType?: string, searchTerm?: string) => {
    const resp = await ContactService.searchContacts(id, 0, 200, undefined, searchTerm, contactType);
    if (resp && resp?.content) {
      setOfficeContacts(resp?.content);
    }
  };

  const handleUserInvite = async () => {
    setIsSubmitting(true);
    try {
      await addReq();
      setShowPatientInviteDialog(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const getPrice = async () => {
      if (id && formType && selectedService && billedToSent && servicePriceOverride) {
        const body: UpdateRequest = {
          officeId: id,
          firstName: firstName,
          lastName: lastName,
          requestType: formType,
          serviceId: selectedService?.serviceId,
          patientId: selectedPatientId,
          serviceBilledToOverride: billedToSent,
          servicePriceOverride: selectedService?.price ?? 0,
          discountType: discountAmount > 0 ? discountType : undefined,
          discountAmount: discountAmount > 0 ? discountAmount : undefined,
          fees: additionalFees,
          recipientName: formType === NewRequestType.ThirdPartyOffice ? recipientName : undefined,
          recipientContact: formType === NewRequestType.ThirdPartyOffice ? recipientContact : undefined,
        };
        const resp = await OfficeService.getPriceReview(id, body);
        if (resp) {
          setPriceDetails(resp);
          if (resp?.totalAmount > 0 && resp?.totalAmount / 100 < 1) {
            toast?.openToast("Minimum transaction amount is $1", 2000, ToastVariants.Error);
          }
        } else setPriceDetails(undefined);
      }
    };
    getPrice();
  }, [id, formType, selectedPatientId, discountType, discountAmount, selectedService, billedToSent, servicePriceOverride, additionalFees]);

  const debouncedFetchContacts = useDebouncedCallback((searchTerm: string) => {
    let contactType = undefined;
    if (formType === NewRequestType.PrescriptionRefill) {
      contactType = "Pharmacy";
    }
    if (id) fetchContacts(id, contactType, searchTerm);
  }, 500);

  useEffect(() => {
    debouncedFetchContacts(selectedContactsearch);
  }, [selectedContactsearch, debouncedFetchContacts, id]);

  return (
    <div className="container mx-auto p-8">
      <BreadCrumbs items={breadCrumbItems} />
      <div className="w-full max-w-2xl">
        <h2 className="font-bold text-2xl mb-2 mt-5">Create New Request</h2>
        <p className="text-base font-medium mb-5">{"To create a new request, search by patient name or manually add patient details below."}</p>
        <div className="py-2">
          <select
            disabled={reqData?.requestType}
            onChange={e => handleFormType(e.target.value as NewRequestType)}
            value={formType}
            className="general-select w-full disabled:opacity-100"
          >
            <option value="">
              Select request type <span className="text-red-500">*</span>
            </option>
            <option value={NewRequestType.QuickFormOffice} key={NewRequestType.QuickFormOffice}>
              {RequestTypeTitle.QuickForm}
            </option>
            <option value={NewRequestType.StandardOffice} key={NewRequestType.StandardOffice}>
              {RequestTypeTitle.NewRequest}
            </option>
            <option value={NewRequestType.ThirdPartyOffice} key={NewRequestType.ThirdPartyOffice}>
              {RequestTypeTitle.ThirdParty}
            </option>
            <option value={NewRequestType.PrescriptionRefill} key={NewRequestType.PrescriptionRefill}>
              {RequestTypeTitle.PrescriptionRefill}
            </option>
            <option value={NewRequestType.DocnoteDebit} key={NewRequestType.DocnoteDebit}>
              {RequestTypeTitle.DocnoteDebit}
            </option>
            <option value={NewRequestType.WSIBOffice} key={NewRequestType.WSIBOffice}>
              {RequestTypeTitle.WSIB}
            </option>
            <option value={NewRequestType.ServiceCanadaOffice} key={NewRequestType.ServiceCanadaOffice}>
              {RequestTypeTitle.ServiceCanada}
            </option>
          </select>
          <div>{!formType && errorInitiated ? <p style={{ color: colors.Red }}>{"Please select request type"}</p> : null}</div>
        </div>
        <div id="create-request-section-1">
          <div className="py-2 relative ">
            {reqData?.firstName && reqData?.email ? (
              <TextInput
                onChangeFunc={() => {}}
                value={reqData?.firstName ? `${reqData?.firstName} ${reqData?.lastName}` : ""}
                placeholder="Enter Value"
                onBlur={() => {}}
                disabled={true}
              />
            ) : (
              <SelectWithSearch
                value={selectedPatient?.firstName ? `${selectedPatient?.firstName} ${selectedPatient?.lastName}` : ""}
                onSearcSelect={newalue => {
                  setselectPatientSearch(newalue);
                }}
                onSelect={newValue => {
                  onOptionSelect(newValue);
                }}
                options={patientOptions ?? []}
                placeholder={"Select Patient"}
                isSearchBox={true}
                searchValue={selectPatientsearch}
                renderOption={option => {
                  return (
                    <div>
                      {option.firstName} {option.lastName}{" "}
                      <div className="text-sm">Date of Birth: {moment(option.dateOfBirth).format("MMM DD, YYYY")}</div>
                    </div>
                  );
                }}
                renderValue={option => {
                  const renderVal = patientOptions?.find(o => `${o?.firstName} ${o?.lastName}` === option);
                  return renderVal ? `${renderVal?.firstName} ${renderVal?.lastName}` : "";
                }}
                onSearchChange={async (e, newValue) => {
                  setselectPatientSearch(newValue);
                  if (newValue.trim().length >= 3) {
                    patientDebounced(newValue);
                  } else if (selectPatientsearch.length > 2) {
                    patientDebounced("");
                  }
                }}
              />
            )}
          </div>
          <div className="mb-3">
            <button
              className="text-docsigna-blue-light font-medium"
              onClick={() => {
                setSelectedPatient("");
              }}
            >
              Manually enter patient information
            </button>
          </div>

          {inputs.slice(0, 3).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
        </div>
        <div id="create-request-section-2">
          {inputs.slice(3, 4).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
        </div>
        <div id="create-request-section-3">
          {inputs.slice(4, 9).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
        </div>
        <div id="create-request-section-4">
          {inputs.slice(9, 11).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
        </div>
        <div id="create-request-section-5">
          {inputs.slice(11, 12).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
        </div>
        <div id="create-request-section-6">
          {inputs.slice(12, 16).map(inp => {
            if (inp.child && inp.child?.length > 0) {
              return renderChildInput(inp);
            }
            return renderInput(inp);
          })}
          <div className="py-2">
            <span className="font-medium">Discount</span>
            <div className="block sm:flex flex-row mt-3">
              <div className="w-full sm:w-1/2">
                <TextInput
                  onChangeFunc={e => handleDiscount("input", e.currentTarget.value)}
                  value={discountValue}
                  placeholder="Enter discount"
                  onBlur={() => handleDiscountBlur()}
                />
              </div>
              <div className="w-full sm:w-1/2 flex flx-row sm:px-8 pt-2 sm:pt-0 items-center">
                <label className="block w-auto sm:w-full mb-1 mr-4 sm:mr-0 relative">
                  <input
                    type={"radio"}
                    checked={discountType === RequestDiscountType.Percentage}
                    onChange={e => handleDiscount("%", e.currentTarget.checked)}
                    className="general-radio bg-transparent"
                  />
                  <span className="text-base ml-2">{"%"}</span>
                </label>
                <label className="block w-auto sm:w-full mb-1 relative">
                  <input
                    type={"radio"}
                    checked={discountType === RequestDiscountType.Amount}
                    onChange={e => handleDiscount("$", e.currentTarget.checked)}
                    className="general-radio bg-transparent"
                  />
                  <span className="text-base ml-2">{"$"}</span>
                </label>
              </div>
            </div>
            {discountError ? <span className="text-red-500">Invalid discount amount</span> : null}
          </div>
        </div>
        {/* Added div for userGuiding */}
        <div id="create-request-section-7">
          <div className="font-semibold py-2">Fees</div>
          <div className="py-2 pb-7">
            <div className="mb-2">
              {priceDetails?.fees?.length
                ? priceDetails?.fees.map((ele: InvoiceDetails, index: number) => {
                    return (
                      <div key={index} className="w-full flex justify-between py-2 border-b">
                        <div className="text-md font-medium">{ele.description}</div>
                        <div className="text-md font-medium">{formatCurrency((ele.amount / 100).toString(), "blue")}</div>
                      </div>
                    );
                  })
                : null}
            </div>
            <button onClick={handleAddAdditionalSideBar} className="text-sm text-docsigna-blue-light font-medium">
              {priceDetails?.fees?.length ? "Add/Edit Fee" : `Add New Fee`}
            </button>
          </div>
        </div>
        <div className="font-semibold py-2">Service Cost</div>
        <div className="mb-3">
          <div className="w-full flex justify-between py-2 border-b">
            <div className="text-md font-medium">Service</div>
            <div className="text-md font-medium">{formatCurrency(servicePrice.toString(), "blur")}</div>
          </div>
          {dscValue > 0 ? (
            <div className="w-full flex justify-between py-2 border-b">
              <div className="text-md font-bold">{dscDesc}</div>
              <div className="text-md font-bold">{formatCurrency(dscValue.toString(), "blur")}</div>
            </div>
          ) : null}
          {blockFeeDiscountAmount > 0 ? (
            <div className="w-full flex justify-between py-2 border-b">
              <div className="text-md font-bold">Annual Plan: {blockFeeDiscountDesc}</div>
              <div className="text-md font-bold">{formatCurrency(blockFeeDiscountAmount.toString(), "blur")}</div>
            </div>
          ) : null}
          <div className="w-full flex justify-between py-2 border-b">
            <div className="text-md font-medium">Additional Fees</div>
            <div className="text-md font-medium">{formatCurrency(additionalFeeTotal.toString(), "blur")}</div>
          </div>
          <div className="w-full flex justify-between py-2 border-b">
            <div className="text-md font-medium">Subtotal</div>
            <div className="text-md font-medium">{formatCurrency(subTotal.toString(), "blur")}</div>
          </div>
          {dsFee > 0 ? (
            <div className="w-full flex justify-between py-2">
              <div className="text-md font-medium">{dsFeeDesc}</div>
              <div className="text-md font-medium">{formatCurrency(dsFee.toString(), "blur")}</div>
            </div>
          ) : null}
          {hstValue > 0 ? (
            <div className="w-full flex justify-between py-2 border-b">
              <div className="text-md font-medium">{hstDesc ? `${hstDesc} (${hstPercentage ? `${hstPercentage}%` : ""})` : "HST"}</div>
              <div className="text-md font-medium">{formatCurrency(hstValue.toString(), "blur")}</div>
            </div>
          ) : null}
          <div className="w-full flex justify-between py-2">
            <div className="text-md font-semibold">Total</div>
            <div className="text-md font-medium">{formatCurrency(total.toString(), "blur")}</div>
          </div>
        </div>
        <div className="py-2 mb-5">
          <p className="text-base mb-2">
            <span className="block text-base  font-bold">Assign Request</span>
          </p>
          <p className="text-base mb-2">Assign this request to internal staff and primary care provider.</p>
          <div className="block sm:flex items-start py-2 gap-2">
            {inputs.slice(MAX_VISIBLE_INPUTS).map(inp => {
              return (inp?.child?.length ?? 0) > 0 ? renderChildInput(inp) : renderInput(inp);
            })}
          </div>
        </div>
        {addRequestError ? (
          <p style={{ color: colors.Red }} className="text-base mb-5">
            {errorMessage}
          </p>
        ) : null}
        <div
          className="w-full sm:w-1/4 mt-5"
          onClick={() => {
            setErrorInitiated(true);
          }}
        >
          <Button
            onClick={() => {
              if (validateForm() && !discountError) saveRequest();
            }}
            disabled={
              ((!validateForm() || discountError) && errorInitiated) || fileLoading || (total > 0 && total < 1) || pending || loading || isSubmitting
            }
            text="Submit Request"
            variant={pending || loading || isSubmitting ? "loading" : "Primary"}
          />
        </div>
      </div>
      <UserSideBar
        onClickOutside={() => {
          setAddSideBarOpen(false);
        }}
        title="Add Fees"
        visible={addSideBarOpen}
      >
        <AddEditFee
          onCancelClick={() => {
            setAddSideBarOpen(false);
          }}
          onSaveClick={(feeData?: UpdateFee[]) => {
            setAddSideBarOpen(false);
            setAdditionalFees(feeData);
          }}
          officeId={id ? id : null}
          requestId={requestData ? requestData.requestId : null}
          addedFee={additionalFees}
        />
      </UserSideBar>
      {searchedUserData?.userState === UserState.Active ? (
        <ConfirmationDialog
          maxWidth="sm"
          successButtonText=""
          failureButtonText=""
          open={true}
          hideActionButtons={false}
          description={getUserData()}
          handleSuccess={() => null}
          handleFailure={() => {
            setSearchedUserData(null);
          }}
          showCrossIcon={false}
        />
      ) : null}
      {showPatientInviteDialog ? (
        <ConfirmationDialog
          open={true}
          title=""
          loading={isSubmitting}
          description={`This patient does not have a Docnote account. They will be sent an invite to join the platform so they can view this request.`}
          successButtonText="Continue"
          failureButtonText="Cancel"
          handleSuccess={() => handleUserInvite()}
          handleFailure={() => {
            if (!isSubmitting) {
              setShowPatientInviteDialog(false);
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default CreateRequestScreen;
